import { FC, PropsWithChildren, useContext } from 'react';
import {
  Analytics,
  gatewayService,
} from 'crono-fe-common/hooks/crono-extension/gateway';
import { useAmplitudeAnalytics } from './useAmplitudeAnalytics';
import { AnalyticsContext } from './contexts';
export const AnalyticsContainer: {
  analytics: Analytics | null;
} = { analytics: null };

// get from env

const AMPLITUDE_API_KEY = process.env.VITE_APP_AMPLITUDE_API_KEY || '';

const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  const analytics = useAmplitudeAnalytics(AMPLITUDE_API_KEY);
  gatewayService.setAnalytics(analytics);
  AnalyticsContainer.analytics = analytics;
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;

export function useAnalytics() {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error(`useAnalytics must be used within a AnalyticsProvider`);
  }

  return context;
}
